














import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { IUser } from '@/store/modules/views/user/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class DeleteCaregiverDialog extends VueExtendedBaseComponent {
  @Prop() private open!: boolean
  @Prop() private user!: IUser
  @Prop() private callback!: () => Promise<void>

  private loading = false

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get deleteCaregiverDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'ลบ',
          action: this.deleteCaregiverAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  private async deleteCaregiverAction() {
    this.loading = true
    const careGiverData = {
      edit: {
        roleId: '11175c71fbe64ad49759e94b7f5b3a07',
        centerId: '',
      },
    }
    try {
      await HttpRequestServiceWithToken.put(
        `${process.env.VUE_APP_API_URL}/v1/all/caregiver/${this.user._id}`,
        careGiverData.edit,
        async () => {
          this.updateSnackbar({txt: 'ลบนักบริบาลสำเร็จ.', type: 'success'})
          await this.callback()
          this.loading = false
          this.closeDialog()
        },
      )
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
